import React, { ImgHTMLAttributes } from "react";
import { getSizedImage } from "@/helpers/utils";

type ImageDimensions = { height: number; width: number };

export type SizedImageProps = ImgHTMLAttributes<HTMLImageElement> &
  ImageDimensions & {
    src: string;
    alt: string;
    opacity?: number;
    scaleFactor?: number;
  };

export const SizedImage = ({
  src,
  alt,
  width,
  height,
  opacity,
  scaleFactor = 1,
  ...rest
}: SizedImageProps) => {
  return (
    <div style={{ width: `${width / scaleFactor}px` }}>
      <img
        style={{
          opacity,
          ...(height && { height: `${height / scaleFactor}px` }),
        }}
        src={getSizedImage(src, `x${height || ""}`)}
        width={width / scaleFactor}
        height={height / scaleFactor}
        {...rest}
        className={`object-cover ${rest.className ?? ""}`}
        alt={alt}
      />
    </div>
  );
};
